import { apiRequest } from '../http.js'

export const influencersApi = {
getAll: async (campaignId = null, options = {}) => {
      const params = new URLSearchParams()
      if (campaignId) params.set('campaignId', campaignId)
      if (options.clientId) params.set('clientId', options.clientId)
      if (options.accountStatus) params.set('accountStatus', options.accountStatus)
      const query = params.toString() ? `?${params.toString()}` : ''
      const data = await apiRequest(`/influencers${query}`, options)
      return data.influencers || []
    },

    
    getByRosterId: async (rosterId, options = {}) => {
      const data = await apiRequest(`/influencers/roster/${rosterId}`, options)
      return { user: data.user, assignments: data.assignments || [] }
    },

    
    deleteRoster: async (rosterId) => {
      await apiRequest(`/influencers/roster/${rosterId}`, { method: 'DELETE' })
    },

    
    createPotential: async (body) => {
      const data = await apiRequest('/influencers/roster', {
        method: 'POST',
        body: JSON.stringify(body),
      })
      return data.influencer
    },

    
    updateRosterProfile: async (rosterId, body) => {
      const data = await apiRequest(`/influencers/roster/${rosterId}`, {
        method: 'PUT',
        body: JSON.stringify(body),
      })
      return data.influencer
    },

    
    sendPlatformInvite: async (rosterId) => {
      return apiRequest(`/influencers/roster/${rosterId}/send-invite`, {
        method: 'POST',
      })
    },

    // Agreements (admin-only): attach documents to influencer roster records
    agreements: {
      
      list: async (rosterId, options = {}) => {
        const data = await apiRequest(`/influencers/roster/${rosterId}/agreements`, options)
        return data.agreements || []
      },
      
      getUploadUrl: async (rosterId, { filename, contentType }) => {
        const data = await apiRequest(`/influencers/roster/${rosterId}/agreements/upload-url`, {
          method: 'POST',
          body: JSON.stringify({ filename, contentType }),
        })
        return { uploadUrl: data.uploadUrl, publicUrl: data.publicUrl, s3Key: data.s3Key }
      },
      
      getDownloadUrl: async (rosterId, agreementId) => {
        const data = await apiRequest(
          `/influencers/roster/${rosterId}/agreements/${agreementId}/download-url`
        )
        return data.downloadUrl
      },
      
      create: async (rosterId, body) => {
        const data = await apiRequest(`/influencers/roster/${rosterId}/agreements`, {
          method: 'POST',
          body: JSON.stringify(body),
        })
        return data.agreement
      },
      
      delete: async (rosterId, agreementId) => {
        await apiRequest(`/influencers/roster/${rosterId}/agreements/${agreementId}`, { method: 'DELETE' })
      },
    },

    
    getByUserId: async (userId, options = {}) => {
      const data = await apiRequest(`/influencers/by-user/${userId}`, options)
      return { user: data.user, assignments: data.assignments || [] }
    },

    
    getAssignments: async (options = {}) => {
      const data = await apiRequest('/influencers/assignments', options)
      return data.influencers || []
    },

    
    invite: async (campaignId, influencerId) => {
      const data = await apiRequest('/influencers/invite', {
        method: 'POST',
        body: JSON.stringify({ campaignId, influencerId }),
      })
      return data.influencer
    },

    
    updateStatus: async (id, status) => {
      const data = await apiRequest(`/influencers/${id}/status`, {
        method: 'PUT',
        body: JSON.stringify({ status }),
      })
      return data.influencer
    },

    
    update: async (id, updates) => {
      const data = await apiRequest(`/influencers/${id}`, {
        method: 'PUT',
        body: JSON.stringify(updates),
      })
      return data.influencer
    },

    
    remove: async (id) => {
      await apiRequest(`/influencers/${id}`, { method: 'DELETE' })
    },
}
